// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"296":"privacy","443":"about","631":"contact","720":"faq"}[chunkId] + "." + {"296":"eb1461be","443":"6a439fb8","631":"0354b224","720":"16e0fd92"}[chunkId] + ".css";
};